import { CategoryIcon } from '@/components/CategoryIcon';
import { getCategoryChipStyle, normalizeCategoryKey } from '@/lib/category';
import { cn } from '@/lib/utils';

interface Props {
  categoryKey: string;
  label: string;
  iconName?: string | null;
  className?: string;
}

/**
 * Category-coloured leading avatar for recurring rows — mirrors the avatar in
 * `transactions/screen/TransactionRow.tsx` so recurring rows read like the rest
 * of the app's lists.
 */
export function RecurringRowAvatar({ categoryKey, label, iconName, className }: Props) {
  const style = getCategoryChipStyle(normalizeCategoryKey(categoryKey));
  return (
    <span
      className={cn('flex size-10 shrink-0 items-center justify-center rounded-[var(--radius-2xl)]', className)}
      style={{ backgroundColor: style.backgroundColor }}
      aria-hidden
      title={label}
    >
      <CategoryIcon name={iconName ?? undefined} className="size-5" style={{ color: style.color }} />
    </span>
  );
}
